import { render, staticRenderFns } from "./QueueOverview.vue?vue&type=template&id=78d3a182&scoped=true"
import script from "./QueueOverview.vue?vue&type=script&lang=js"
export * from "./QueueOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d3a182",
  null
  
)

export default component.exports